/// <reference path="../../../../node_modules/@1js/office-online-strings/en-US/transcription-strings.d.ts" />

import * as React from 'react';
import { Label, Image } from 'office-ui-fabric-react';
import { AppButton } from '../../components';
import { RouteComponentProps } from 'react-router-dom';
import failureStore from '../../stores/FailureStore';
import { ChangeEvent } from '../../stores/utils';
import { LogEvents } from '../../../utils/LogEvents';
import { StartOverKeys } from '../../common/telemetry/StartOverKeys';
import { AppLayoutSettings, getMainPageStyles } from '../../common/styles/common.styles';
import { StartOverClicked } from '../../actions/TranscribingActions';
import { RetryClicked } from '../../actions/FailureActions';
import { failureRetryButtonContainerStyle } from './Failure.styles';
import {failureImageContainerStyle} from '../../common/pageStyles/FailurePage.styles'
import { HostAppSettings, HostAppSettingName } from '../../../backend/office-js/HostAppSettings';
import { AudioBackupAndRealTimeTranscriptionConnection } from '../../common/connections/AudioBackupAndRealTimeTranscriptionConnection';
import { FailureContinuation } from '../../common/enums/failureEnums';
import { TranscriptionAlert } from '../../components/Popups/TranscriptionAlert';
import { GetNetworkConnectionMonitorInstance, InternetState, NetworkConnectionListener } from '../../NetworkConnectionMonitor';

export interface FailureState {
  failureReason: string,
  failureContinuation: FailureContinuation
}

// This component is a placeholder whilst the final design is finalized
export class Failure extends React.PureComponent<RouteComponentProps<{}, {}, AudioBackupAndRealTimeTranscriptionConnection>, FailureState>
implements NetworkConnectionListener {
  private _isMounted: boolean;

  constructor(props: RouteComponentProps<{}, {}, AudioBackupAndRealTimeTranscriptionConnection>) {
    super(props);
    this._isMounted = false;

    this.state = failureStore.getState();
    failureStore.on(ChangeEvent.Change, this._onStoreChanged);
  }

  onInternetConnectionStatusChanged(state: InternetState): void {
    switch(state) {
      case InternetState.INTERNET_CONNECTED:
        GetNetworkConnectionMonitorInstance().removeListener(this);
        location.reload();
        break;
    }
  }

  private RetryButtonLabelFromFailureContinuation(continuation: FailureContinuation) {
    switch (continuation) {
      case FailureContinuation.StartOver:
        return TranscriptionStrings.StartOverFailureButtonLabel;
      case FailureContinuation.Cancel:
        return TranscriptionStrings.CancelButtonName;
      case FailureContinuation.Retry:
      default:
        return TranscriptionStrings.RetryFailureButtonLabel;
    }
  }

  public componentDidMount() {
    this._isMounted = true;
    if (this.state.failureContinuation == FailureContinuation.RecoveryonInternetConnected) {
      GetNetworkConnectionMonitorInstance().addListener(this);
    }
  }

  public componentWillUnmount() {
    this._isMounted = false;
    GetNetworkConnectionMonitorInstance().removeListener(this);
  }

  public render() {
    const styles = getMainPageStyles();

    return (
      <div style={AppLayoutSettings.AppCommonStyles.getPageRootContainersCSSProperties()}>
        <Label role="alert" styles={AppLayoutSettings.AppCommonStyles.getPageTopLabelStyles()}>{this.state.failureReason}</Label>
        <div className={styles.imageContainer} style={failureImageContainerStyle}>
          <Image alt="" src={require('../../../../assets/' + AppLayoutSettings.AppImageParams.failureImageName)} width={AppLayoutSettings.AppImageParams.failureImageWidthPx} height={AppLayoutSettings.AppImageParams.failureImageHeightPx} />
        </div>
        {this.shouldShowRetryButton() ?
          <div className={styles.buttonContainer} style={failureRetryButtonContainerStyle}>
            <AppButton id="retryButton" type={'AppButtonProps'} text={this.RetryButtonLabelFromFailureContinuation(this.state.failureContinuation)} onExecute={this._onRetryButtonClicked} />
          </div> : null}
          <TranscriptionAlert/>
      </div>
    );
  }

  private shouldShowRetryButton() {
    return (this.state.failureContinuation != FailureContinuation.None &&
      this.state.failureContinuation != FailureContinuation.RecoveryonInternetConnected);
  }

  private _onRetryButtonClicked = async () => {
    switch (this.state.failureContinuation) {
      case FailureContinuation.Retry:
        if (HostAppSettings.IsSettingTrue(HostAppSettingName.HasStoredTranscription)) {
          await RetryClicked(this.props.history);
        } else {
          await this.PerformStartOverClicked();
        }

        break;
      case FailureContinuation.StartOver:
        await this.PerformStartOverClicked();
        break;
      case FailureContinuation.Cancel:
        await this.clearBackupAndInitialiseIndexedDB();
        await this.PerformStartOverClicked();
        break;
    }
  }

  private async clearBackupAndInitialiseIndexedDB() {
    if ( this.props.location.state.audioBackup != null) {
      await this.props.location.state.audioBackup.ClearBackup();
      await this.props.location.state.audioBackup.Initialize();
    }
  }

  private async PerformStartOverClicked() {
    LogEvents.StartOver.Start([{ key: StartOverKeys.Reason, value: "Failure" }, { key: StartOverKeys.FailureContinuation, value: this.state.failureContinuation }]);
    await StartOverClicked(this.props.history);
    LogEvents.StartOver.End();
  }

  private _onStoreChanged = (): void => {
    if (this._isMounted) {
      this.setState(failureStore.getState());
    }
  };
}
